module.exports = __webpack_public_path__ + "img/tianqi.f645fc52.png";